import classNames from 'classnames/bind';

import { EmptyAvatar } from '../../assets/icons/Icons';
import Styles from './profilepicture.module.scss';

const cx = classNames.bind(Styles);

export interface Props {
  /** URL of image being displayed */
  url: string;
  /** String representing size of the image */
  size?: 'xs' | 'small' | 'medium' | 'large';
  /** userID, optional for generating photo URL */
  userID?: string;
  /** Full name of Employee */
  name: string;
  /** Flag to display profile picture as a circle */
  circular?: boolean;
  /** Class Name for custom stylings for the profile picture */
  className?: string;
}

// Should probably be a forwardRef for the img tag
const ProfilePicture = ({ url, userID, size = 'small', name, circular, className }: Props) => {
  if (!name) {
    return null;
  }

  let urlToUse: string | undefined;
  if (url) {
    urlToUse = url;
  } else if (userID) {
    urlToUse = `/users/${userID}/photo/${size}`;
  }

  return (
    <img
      src={urlToUse || EmptyAvatar}
      alt={urlToUse ? 'Profile Picture of Employee, ' + name : 'Empty Avatar Icon'}
      className={cx('photo', size, { circular }, className)}
    />
  );
};

export default ProfilePicture;
